const KeyMilestones = () => {
    return (
        <div className="KeyMilestones">
            <h3>Core Competencies</h3>
            <div className="milestones">
                <div className="milestone">
                    <b>2013</b>
                    <span>
                        Formation of Dentons through
                        three-way merger
                    </span>
                </div>
                <div className="milestone">
                    <b>2015</b>
                    <span>
                        Merger with Dacheng Law Offices in
                        China
                    </span>
                </div>
                <div className="milestone">
                    <b>2020</b>
                    <span>
                        Launch of Dentons Global Advisors
                    </span>
                </div>
            </div>
        </div>
    );
};

export default KeyMilestones;
